import React, { useContext } from 'react';
import { ResultsContext } from '../contexts/ResultsContext';
import RefreshIcon from '@mui/icons-material/Refresh';

function RefreshButton() {
  const { tournamentId, fetchResults, startAutomaticRefresh } = useContext(ResultsContext);

  const handleRefresh = () => {
    if (tournamentId) {
      fetchResults(tournamentId);
      startAutomaticRefresh(5); // Restart automatic refresh with 5 minute intervals
    }
  };

  return (
    <button 
      className="refresh-button" 
      onClick={handleRefresh}
      aria-label="Refresh data"
    >
      <RefreshIcon />
    </button>
  );
}

export default RefreshButton;